import { useEffect, useMemo, useState } from "react";
import { useAuth } from "@clerk/react";
import { useSearchParams, Link } from "react-router-dom";
import { CheckCircle2, Loader2 } from "lucide-react";
import Shell from "@/components/Shell";
import { makeApi } from "@/lib/api";

export default function PaymentSuccess() {
  const { getToken } = useAuth();
  const api = useMemo(() => makeApi(getToken), [getToken]);
  const [params] = useSearchParams();
  const sessionId = params.get("session_id");
  const [status, setStatus] = useState("pending");
  const [tries, setTries] = useState(0);

  useEffect(() => {
    if (!sessionId) return;
    let cancelled = false;
    const poll = async () => {
      try {
        const { data } = await api.get(`/payments/status/${sessionId}`);
        if (cancelled) return;
        setStatus(data.payment_status);
        if (data.payment_status !== "paid" && tries < 20) {
          setTimeout(() => setTries((t) => t + 1), 2000);
        }
      } catch {
        if (tries < 20) setTimeout(() => setTries((t) => t + 1), 2000);
      }
    };
    poll();
    return () => { cancelled = true; };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [sessionId, tries]);

  return (
    <Shell>
      <div className="max-w-xl mx-auto brutal-border bg-[#141414] p-10 text-center" data-testid="payment-success-card">
        {status === "paid" ? (
          <>
            <CheckCircle2 size={48} className="text-emerald-400 mx-auto mb-4" />
            <h1 className="font-heading font-black text-3xl mb-2">Payment confirmed.</h1>
            <p className="text-muted-foreground mb-6">You're all set. Head back to the dashboard to continue your launch.</p>
          </>
        ) : (
          <>
            <Loader2 size={36} className="text-[#FFD600] mx-auto mb-4 animate-spin" />
            <h1 className="font-heading font-black text-2xl mb-2">Confirming your payment…</h1>
            <p className="text-muted-foreground mb-6">This usually takes just a few seconds.</p>
          </>
        )}
        <Link to="/dashboard" data-testid="success-go-dashboard" className="cta-primary inline-block px-5 py-3 font-mono-label text-xs">Go to Dashboard</Link>
      </div>
    </Shell>
  );
}
